// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.apm-a{
  display:flex;
  flex-direction:column;
}

.icon-chat-user-apm {
  width: 25px;
  position: absolute;
  margin-left: 10px;
  /* margin-right: 10px; */
  /* bottom: -15px; */
  /* left: -5px; */
}

.icon-chat-bot-apm {
  width: 25px;
  position: absolute;
  margin-left: 10px;
  /* margin-right: 50px; */
  /* bottom: -15px; */
  /* right: -5px; */
}
.let-apm:hover {
  color: #D8AC1B;
  font-size: 14px;
  font-weight: 600;
  padding-top: 20px;
}
::-webkit-scrollbar-track {

background: #747BA9;

}


/* Handle */

::-webkit-scrollbar-thumb {

background: #fff;

}



/* Handle on hover */

::-webkit-scrollbar-thumb:hover {

background: #fff;  

}
.apm-img{
  width:109%;
  margin-left:20px;
  margin-right:20px;
}
.bottom-apm{
  display:flex;
  flex-direction:column;
  margin:20px;
  height:250px;
  width:109%;
  background-color:rgba(255, 255, 255, 0.05);
  border-radius:10px;
}
.feature-apm{
  color:white;
  margin-left:10px;
  border-bottom:1px solid #AD8BFF;
  padding-top:10px;
  padding-bottom:10px;
  font-weight:500;
  font-size:14px;

}

.left-apm{
  display:flex;
  flex-direction:column;
  width:750px;
}
.bot {
min-width: 300px;

position: relative;
max-width: 640px;

/* min-height: 60px; */
/* max-height: 100%; */
/* height: fit-content; */
/* display: block; */
/* overflow: auto; */
padding: 10px;
color: white;
text-align: left;
/* margin-right: 30px; */
width: fit-content;
float: left;

}
.feedback-icons .icon {
  margin-left: 10px; /* Add space between icons */
  cursor: pointer;
  transition: color 0.3s; /* Add transition for color change */
}
.feedback-icons .icon:hover {
  color: #c3aff0; /* Change color on hover */
}
.feedback-icons .icon:active{
color:#00c853;
}
.feedback-icons .icon:liked{
  color:#00c853;
  }

.icon.dislike-icon.active {
  color: #00c853; /* Your liked color */
}
.icons{
  margin-left: 10px;
}
/* Apply specific color to disliked icon */
.icon.dislike-icon.disliked {
  color: #ff1744; /* Your disliked color */
}

  /* Apm.css */

/* Add your default styles for the icons here */


/* Styles for the clicked (liked) icon */
.icon.clicked {
  color: green; /* Change the color for the clicked icon */
}

/* Styles for the not clicked (default) icon */
.icon.not-clicked {
  color: grey; /* Change the color for the not clicked icon */
}
.feedback-icons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 5px; /* Add space between message and icons */
}
.user-message{
  padding-left: 10px;
  padding-top: 3px;
}
.bot-message{
  padding-left: 10px;
  padding-top: 3px;
}
.bg-user-apm {
  background-color: #4D5699;
  border-radius: 0px 10px 10px 10px;
  border-style: icon solid;
  padding: 10px;
  min-width: 50px;
  
}

.bg-bot-apm {
  background-color: rgba(45, 50, 90, 1);
  padding: 10px;
  border-radius: 0px 10px 10px 10px;
  min-width: 500px;
  max-width: 1200px;
  /* height: auto; */
}
.user {

    /* align-items: end; */
min-width: 50px;
margin-top: 10px;
margin-bottom: 10px;
/* margin-right:10px; */
/* margin-left: 100px; */
text-align: left;
position: relative;
max-width: 500px;
/* padding: 10px; */
width: fit-content;
float: left;

}
 .top-suma1{
  width: 2.5%;
 margin-left: 100px;
  margin-right: 5px;
 

}
.top-suma2{
  width: 2.5%;
 margin-left: 120px;
  margin-right: 5px;
 

}
.chatboticon {
  
  float: right;
}
.top-suma{
  width: 2.5%;
  
 
 
}
.Heading-apm{
  color:#fff;
  margin-right: 700px;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  padding: 20px
}
.chat-messages-apm {
  overflow-y: scroll;
  max-height: 450px;
  margin-bottom: 10px;

}
.message-icon-s{
  margin-right: 20px;
  
 
}
.top-apm{
  display:flex;
  width: 115%;
  flex-direction:row;
}
.top-apm1{
  display:flex;
  width: 110%;
  flex-direction:row;
}
.chat-message-apm {

  padding: 10px;
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
  
  border-radius: 5px;

  font-family: 'Graphik', sans-serif;

 

}

.top-left-apm{
  border-radius:5px;
  border:1px solid #747BA9;
  color:white;
  font-size:14px;
  background-color:rgba(255, 255, 255, 0.05);
  margin-bottom:10px;
  padding-left:10px;
  padding-top:10px;
  height:40px;
  
}
.send-apm{
  width: 50%;
  background-color:#252843;
  border: 1px solid #747BA9;
  border-radius: 5px;
  padding: 3px;
  margin-top: 10px;
}
.accb-img{
  width: 4%;
  margin-left: 20px;
  margin-top: 5px;
}
.bottom-top-apm{
  background-color:#252843;
  border-top:1px solid #6B5CD1;
  display: flex;
  flex-direction: row;
  height: 40px;
}
.chat-input1-apm::placeholder{
 
  color:#fff;
  font-size: 12px;
  padding-left: 10px;
  font-style: italic;
  text-align:start;
}
.bottom-b-apm{
  max-height: 350px;
}
.mic1-apm{
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  margin-top: 65px;
}
.right-t-apm{
border-bottom: 1px solid rgba(14, 190, 147, 1);
min-height: 330px;
}
.chat-input-apm{
  margin-left: 20px;
  margin-top: 10px;
  color: white;
  font-size: 12px;
  display: flex;
  flex-direction: row;
}
.chat-input1-apm{
  background-color:#252843;
  border: 1px solid #747BA9;
  border-radius: 5px;
  font-size: 12px;
  color: white;
  min-height: 150px;
  max-height: 150px;
  width: 310px;
}
.button-apm{
background-color: #6B5CD1;
border: 1px solid #6B5CD1;
width: 80px;
margin-top: 20px;
border-radius: 10px;
margin-left: 150px;
margin-right: 50px;
color: #fff;
}
.date-pick{
  font-size:10px;
  background-color:#252843;
  color:white;
  margin-left:10px;
  margin-top:20px;
  padding-left: 22px;
  border-radius:5px;
  border: 1px solid #747BA9;
  width:69px;
  height:25px;
}
.cal-img{
  width:7%;
  margin-left:20px;
  margin-right:10px;
  margin-top:20px;
}
.react-datepicker__close-icon::after {
  cursor: none;
  background-color: #252843;
  color: #252843;
  border-radius: 10px;
  padding-top:20px;
  height: 0px;
  width: 16px;
  padding: 2px;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  content: "";
}
.table-container{
max-width:600px;
overflow-x:scroll;
}
.img-apm-s{
  display:flex;
  flex-direction:row;
}
.key-apm{
  font-size:12px;
  margin-top:20px;
  padding-left:20px;
}
.Category-select{
  background-color:#252843;
  width:200px;
  margin-top:20px;
  font-size: 12px;
  height: 30px;
  justify-content:right;
  border: 1px solid #747BA9;
  color:white;
}
.side-apm{
  display:flex;
  flex-direction:row;
}
.bottom-left-apm{
  border-radius:5px;
  position: relative;
  border:1px solid #6B5CD1;
  height:500px;
 
}
.asset-img{
  width:3%;
  margin-left:40px;
  margin-top:20px;
}
.right-apm{
  display:flex;
  background-color:rgba(255, 255, 255, 0.05);
  margin-left:10px;
  border-radius:5px;
  border:1px solid #747BA9;
  color:white;
  height:550px;
  width:380px;
  flex-direction:column;
}
.performance-apm{
  display:flex;
  flex-direction:column;
 
  margin-left:20px;
  margin-right:20px;
}
.performance1-apm{
display:flex;
flex-direction:row;
margin-left:20px;
margin-right:20px;
}
.let-apm{
  color:#D8AC1B;
  cursor: pointer;
  font-size:12px;
  font-weight:500;
  padding-top:20px;
}
.bottom1-apm{
  margin-left:10px;
  margin-right:10px;
  margin-bottom:15px;
  margin-top:20px;
  width:40%;
  border-radius:10px;
  padding:10px;
  height:180px;
  background-color:#3C4069;
  border:1px solid #747BA9;
  color:white;
}
.bottom2-apm{
  display:flex;
  margin-left:10px;
  margin-right:10px;
  margin-bottom:10px;
  flex-direction:row;  
}
.heading1-apm{
  color:white;
  font-size:14px;
  font-weight:500;
}
.text1-apm{
  font-size:12px;

}`, "",{"version":3,"sources":["webpack://./src/Apm.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;AAEA,mBAAmB;;AAEnB;;;AAGA,WAAW;;AAEX;;AAEA,gBAAgB;;AAEhB;;;;AAIA,oBAAoB;;AAEpB;;AAEA,gBAAgB;;AAEhB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;;AAEhB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,WAAW;AACb;AACA;AACA,gBAAgB;;AAEhB,kBAAkB;AAClB,gBAAgB;;AAEhB,sBAAsB;AACtB,sBAAsB;AACtB,yBAAyB;AACzB,oBAAoB;AACpB,oBAAoB;AACpB,aAAa;AACb,YAAY;AACZ,gBAAgB;AAChB,wBAAwB;AACxB,kBAAkB;AAClB,WAAW;;AAEX;AACA;EACE,iBAAiB,EAAE,4BAA4B;EAC/C,eAAe;EACf,sBAAsB,EAAE,oCAAoC;AAC9D;AACA;EACE,cAAc,EAAE,0BAA0B;AAC5C;AACA;AACA,aAAa;AACb;AACA;EACE,aAAa;EACb;;AAEF;EACE,cAAc,EAAE,qBAAqB;AACvC;AACA;EACE,iBAAiB;AACnB;AACA,0CAA0C;AAC1C;EACE,cAAc,EAAE,wBAAwB;AAC1C;;EAEE,YAAY;;AAEd,+CAA+C;;;AAG/C,wCAAwC;AACxC;EACE,YAAY,EAAE,0CAA0C;AAC1D;;AAEA,8CAA8C;AAC9C;EACE,WAAW,EAAE,8CAA8C;AAC7D;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe,EAAE,wCAAwC;AAC3D;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,wBAAwB;EACxB,aAAa;EACb,eAAe;;AAEjB;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;IAEI,sBAAsB;AAC1B,eAAe;AACf,gBAAgB;AAChB,mBAAmB;AACnB,uBAAuB;AACvB,wBAAwB;AACxB,gBAAgB;AAChB,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB,kBAAkB;AAClB,WAAW;;AAEX;CACC;EACC,WAAW;CACZ,kBAAkB;EACjB,iBAAiB;;;AAGnB;AACA;EACE,WAAW;CACZ,kBAAkB;EACjB,iBAAiB;;;AAGnB;AACA;;EAEE,YAAY;AACd;AACA;EACE,WAAW;;;;AAIb;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf;AACF;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;;AAErB;AACA;EACE,kBAAkB;;;AAGpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;;EAElB,kBAAkB;;EAElB,kCAAkC;;;;AAIpC;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;;AAEb;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;AACA,8CAA8C;AAC9C,iBAAiB;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;AACA;AACA,yBAAyB;AACzB,yBAAyB;AACzB,WAAW;AACX,gBAAgB;AAChB,mBAAmB;AACnB,kBAAkB;AAClB,kBAAkB;AAClB,WAAW;AACX;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;EACV,WAAW;AACb;AACA;EACE,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;AACA;AACA,eAAe;AACf,iBAAiB;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;;AAEd;AACA;EACE,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,qBAAqB;;EAErB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;AACA,YAAY;AACZ,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;;AAEhB","sourcesContent":[".apm-a{\r\n  display:flex;\r\n  flex-direction:column;\r\n}\r\n\r\n.icon-chat-user-apm {\r\n  width: 25px;\r\n  position: absolute;\r\n  margin-left: 10px;\r\n  /* margin-right: 10px; */\r\n  /* bottom: -15px; */\r\n  /* left: -5px; */\r\n}\r\n\r\n.icon-chat-bot-apm {\r\n  width: 25px;\r\n  position: absolute;\r\n  margin-left: 10px;\r\n  /* margin-right: 50px; */\r\n  /* bottom: -15px; */\r\n  /* right: -5px; */\r\n}\r\n.let-apm:hover {\r\n  color: #D8AC1B;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  padding-top: 20px;\r\n}\r\n::-webkit-scrollbar-track {\r\n\r\nbackground: #747BA9;\r\n\r\n}\r\n\r\n\r\n/* Handle */\r\n\r\n::-webkit-scrollbar-thumb {\r\n\r\nbackground: #fff;\r\n\r\n}\r\n\r\n\r\n\r\n/* Handle on hover */\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n\r\nbackground: #fff;  \r\n\r\n}\r\n.apm-img{\r\n  width:109%;\r\n  margin-left:20px;\r\n  margin-right:20px;\r\n}\r\n.bottom-apm{\r\n  display:flex;\r\n  flex-direction:column;\r\n  margin:20px;\r\n  height:250px;\r\n  width:109%;\r\n  background-color:rgba(255, 255, 255, 0.05);\r\n  border-radius:10px;\r\n}\r\n.feature-apm{\r\n  color:white;\r\n  margin-left:10px;\r\n  border-bottom:1px solid #AD8BFF;\r\n  padding-top:10px;\r\n  padding-bottom:10px;\r\n  font-weight:500;\r\n  font-size:14px;\r\n\r\n}\r\n\r\n.left-apm{\r\n  display:flex;\r\n  flex-direction:column;\r\n  width:750px;\r\n}\r\n.bot {\r\nmin-width: 300px;\r\n\r\nposition: relative;\r\nmax-width: 640px;\r\n\r\n/* min-height: 60px; */\r\n/* max-height: 100%; */\r\n/* height: fit-content; */\r\n/* display: block; */\r\n/* overflow: auto; */\r\npadding: 10px;\r\ncolor: white;\r\ntext-align: left;\r\n/* margin-right: 30px; */\r\nwidth: fit-content;\r\nfloat: left;\r\n\r\n}\r\n.feedback-icons .icon {\r\n  margin-left: 10px; /* Add space between icons */\r\n  cursor: pointer;\r\n  transition: color 0.3s; /* Add transition for color change */\r\n}\r\n.feedback-icons .icon:hover {\r\n  color: #c3aff0; /* Change color on hover */\r\n}\r\n.feedback-icons .icon:active{\r\ncolor:#00c853;\r\n}\r\n.feedback-icons .icon:liked{\r\n  color:#00c853;\r\n  }\r\n\r\n.icon.dislike-icon.active {\r\n  color: #00c853; /* Your liked color */\r\n}\r\n.icons{\r\n  margin-left: 10px;\r\n}\r\n/* Apply specific color to disliked icon */\r\n.icon.dislike-icon.disliked {\r\n  color: #ff1744; /* Your disliked color */\r\n}\r\n\r\n  /* Apm.css */\r\n\r\n/* Add your default styles for the icons here */\r\n\r\n\r\n/* Styles for the clicked (liked) icon */\r\n.icon.clicked {\r\n  color: green; /* Change the color for the clicked icon */\r\n}\r\n\r\n/* Styles for the not clicked (default) icon */\r\n.icon.not-clicked {\r\n  color: grey; /* Change the color for the not clicked icon */\r\n}\r\n.feedback-icons {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  margin-top: 5px; /* Add space between message and icons */\r\n}\r\n.user-message{\r\n  padding-left: 10px;\r\n  padding-top: 3px;\r\n}\r\n.bot-message{\r\n  padding-left: 10px;\r\n  padding-top: 3px;\r\n}\r\n.bg-user-apm {\r\n  background-color: #4D5699;\r\n  border-radius: 0px 10px 10px 10px;\r\n  border-style: icon solid;\r\n  padding: 10px;\r\n  min-width: 50px;\r\n  \r\n}\r\n\r\n.bg-bot-apm {\r\n  background-color: rgba(45, 50, 90, 1);\r\n  padding: 10px;\r\n  border-radius: 0px 10px 10px 10px;\r\n  min-width: 500px;\r\n  max-width: 1200px;\r\n  /* height: auto; */\r\n}\r\n.user {\r\n\r\n    /* align-items: end; */\r\nmin-width: 50px;\r\nmargin-top: 10px;\r\nmargin-bottom: 10px;\r\n/* margin-right:10px; */\r\n/* margin-left: 100px; */\r\ntext-align: left;\r\nposition: relative;\r\nmax-width: 500px;\r\n/* padding: 10px; */\r\nwidth: fit-content;\r\nfloat: left;\r\n\r\n}\r\n .top-suma1{\r\n  width: 2.5%;\r\n margin-left: 100px;\r\n  margin-right: 5px;\r\n \r\n\r\n}\r\n.top-suma2{\r\n  width: 2.5%;\r\n margin-left: 120px;\r\n  margin-right: 5px;\r\n \r\n\r\n}\r\n.chatboticon {\r\n  \r\n  float: right;\r\n}\r\n.top-suma{\r\n  width: 2.5%;\r\n  \r\n \r\n \r\n}\r\n.Heading-apm{\r\n  color:#fff;\r\n  margin-right: 700px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  font-size: 12px;\r\n  padding: 20px\r\n}\r\n.chat-messages-apm {\r\n  overflow-y: scroll;\r\n  max-height: 450px;\r\n  margin-bottom: 10px;\r\n\r\n}\r\n.message-icon-s{\r\n  margin-right: 20px;\r\n  \r\n \r\n}\r\n.top-apm{\r\n  display:flex;\r\n  width: 115%;\r\n  flex-direction:row;\r\n}\r\n.top-apm1{\r\n  display:flex;\r\n  width: 110%;\r\n  flex-direction:row;\r\n}\r\n.chat-message-apm {\r\n\r\n  padding: 10px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin-bottom: 5px;\r\n  \r\n  border-radius: 5px;\r\n\r\n  font-family: 'Graphik', sans-serif;\r\n\r\n \r\n\r\n}\r\n\r\n.top-left-apm{\r\n  border-radius:5px;\r\n  border:1px solid #747BA9;\r\n  color:white;\r\n  font-size:14px;\r\n  background-color:rgba(255, 255, 255, 0.05);\r\n  margin-bottom:10px;\r\n  padding-left:10px;\r\n  padding-top:10px;\r\n  height:40px;\r\n  \r\n}\r\n.send-apm{\r\n  width: 50%;\r\n  background-color:#252843;\r\n  border: 1px solid #747BA9;\r\n  border-radius: 5px;\r\n  padding: 3px;\r\n  margin-top: 10px;\r\n}\r\n.accb-img{\r\n  width: 4%;\r\n  margin-left: 20px;\r\n  margin-top: 5px;\r\n}\r\n.bottom-top-apm{\r\n  background-color:#252843;\r\n  border-top:1px solid #6B5CD1;\r\n  display: flex;\r\n  flex-direction: row;\r\n  height: 40px;\r\n}\r\n.chat-input1-apm::placeholder{\r\n \r\n  color:#fff;\r\n  font-size: 12px;\r\n  padding-left: 10px;\r\n  font-style: italic;\r\n  text-align:start;\r\n}\r\n.bottom-b-apm{\r\n  max-height: 350px;\r\n}\r\n.mic1-apm{\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-left: 5px;\r\n  margin-top: 65px;\r\n}\r\n.right-t-apm{\r\nborder-bottom: 1px solid rgba(14, 190, 147, 1);\r\nmin-height: 330px;\r\n}\r\n.chat-input-apm{\r\n  margin-left: 20px;\r\n  margin-top: 10px;\r\n  color: white;\r\n  font-size: 12px;\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n.chat-input1-apm{\r\n  background-color:#252843;\r\n  border: 1px solid #747BA9;\r\n  border-radius: 5px;\r\n  font-size: 12px;\r\n  color: white;\r\n  min-height: 150px;\r\n  max-height: 150px;\r\n  width: 310px;\r\n}\r\n.button-apm{\r\nbackground-color: #6B5CD1;\r\nborder: 1px solid #6B5CD1;\r\nwidth: 80px;\r\nmargin-top: 20px;\r\nborder-radius: 10px;\r\nmargin-left: 150px;\r\nmargin-right: 50px;\r\ncolor: #fff;\r\n}\r\n.date-pick{\r\n  font-size:10px;\r\n  background-color:#252843;\r\n  color:white;\r\n  margin-left:10px;\r\n  margin-top:20px;\r\n  padding-left: 22px;\r\n  border-radius:5px;\r\n  border: 1px solid #747BA9;\r\n  width:69px;\r\n  height:25px;\r\n}\r\n.cal-img{\r\n  width:7%;\r\n  margin-left:20px;\r\n  margin-right:10px;\r\n  margin-top:20px;\r\n}\r\n.react-datepicker__close-icon::after {\r\n  cursor: none;\r\n  background-color: #252843;\r\n  color: #252843;\r\n  border-radius: 10px;\r\n  padding-top:20px;\r\n  height: 0px;\r\n  width: 16px;\r\n  padding: 2px;\r\n  font-size: 12px;\r\n  line-height: 1;\r\n  text-align: center;\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n  content: \"\";\r\n}\r\n.table-container{\r\nmax-width:600px;\r\noverflow-x:scroll;\r\n}\r\n.img-apm-s{\r\n  display:flex;\r\n  flex-direction:row;\r\n}\r\n.key-apm{\r\n  font-size:12px;\r\n  margin-top:20px;\r\n  padding-left:20px;\r\n}\r\n.Category-select{\r\n  background-color:#252843;\r\n  width:200px;\r\n  margin-top:20px;\r\n  font-size: 12px;\r\n  height: 30px;\r\n  justify-content:right;\r\n  border: 1px solid #747BA9;\r\n  color:white;\r\n}\r\n.side-apm{\r\n  display:flex;\r\n  flex-direction:row;\r\n}\r\n.bottom-left-apm{\r\n  border-radius:5px;\r\n  position: relative;\r\n  border:1px solid #6B5CD1;\r\n  height:500px;\r\n \r\n}\r\n.asset-img{\r\n  width:3%;\r\n  margin-left:40px;\r\n  margin-top:20px;\r\n}\r\n.right-apm{\r\n  display:flex;\r\n  background-color:rgba(255, 255, 255, 0.05);\r\n  margin-left:10px;\r\n  border-radius:5px;\r\n  border:1px solid #747BA9;\r\n  color:white;\r\n  height:550px;\r\n  width:380px;\r\n  flex-direction:column;\r\n}\r\n.performance-apm{\r\n  display:flex;\r\n  flex-direction:column;\r\n \r\n  margin-left:20px;\r\n  margin-right:20px;\r\n}\r\n.performance1-apm{\r\ndisplay:flex;\r\nflex-direction:row;\r\nmargin-left:20px;\r\nmargin-right:20px;\r\n}\r\n.let-apm{\r\n  color:#D8AC1B;\r\n  cursor: pointer;\r\n  font-size:12px;\r\n  font-weight:500;\r\n  padding-top:20px;\r\n}\r\n.bottom1-apm{\r\n  margin-left:10px;\r\n  margin-right:10px;\r\n  margin-bottom:15px;\r\n  margin-top:20px;\r\n  width:40%;\r\n  border-radius:10px;\r\n  padding:10px;\r\n  height:180px;\r\n  background-color:#3C4069;\r\n  border:1px solid #747BA9;\r\n  color:white;\r\n}\r\n.bottom2-apm{\r\n  display:flex;\r\n  margin-left:10px;\r\n  margin-right:10px;\r\n  margin-bottom:10px;\r\n  flex-direction:row;  \r\n}\r\n.heading1-apm{\r\n  color:white;\r\n  font-size:14px;\r\n  font-weight:500;\r\n}\r\n.text1-apm{\r\n  font-size:12px;\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
